<template>
  <div id="einsatz-auf-angebot-uebertragen-modal" class="modal fade">
    <div class="modal-dialog">
      <div class="modal-content">
        <ValidationObserver v-slot="{ invalid }" :disabled="true">
          <div class="modal-header">
            <modal-close-button @confirmed="closeModal" />
            <h4 class="modal-title">{{ $t("global.transferToAnotherOffer") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xl-12">
                <span
                  >{{ $t("global.selectOfferToTransfer") }}</span
                >
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-xl-12">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <v-select
                      v-model="angebot"
                      class="mt-2 mb-3"
                      v-bind:class="{ 'border-danger': !passed }"
                      :getOptionLabel="
                        (feld) => feld.bezeichnung + ' / ' + feld.kuerzel
                      "
                      :options="angebote"
                      placeholder="Angebot"
                    >
                      <span slot="no-options">{{
                        $t("global.taptosearch")
                      }}</span>
                    </v-select>
                    <label v-bind:class="{ 'text-danger': !passed }"
                      >{{ $t("global.offer") }}</label
                    >
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="closeModal">
              {{ $t("global.cancel") }}
            </button>
            <button
              type="button"
              :disabled="invalid"
              class="btn btn-primary"
              @click="uebernehmen"
            >
              {{ $t("global.transfer") }}
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";
import ModalCloseButton from "@/components/global/ModalCloseButton";

import AppApi from "@/api/AppApi";

export default {
  name: "EinsatzAufAngebotUebertragenModal",
  components: {
    ModalCloseButton,
  },
  mixins: [modal],

  props: {},
  data() {
    return {
      shown: false,
      angebote: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$bus.$on("open-einsatz-uebertragen-modal", () => {
      if (!this.shown) this.openModal();
    });

    // this.getAngebote();
  },
  methods: {
    getAngebote() {
      AppApi.get("angebotliste").then((response) => {});
    },
    openModal() {
      this.shown = true;

      $("#einsatz-auf-angebot-uebertragen-modal").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    closeModal() {
      this.shown = false;
      $("#einsatz-auf-angebot-uebertragen-modal").modal("hide");
    },
    uebernehmen() {
      this.$emit("confirmed", this.angebot);
      this.closeModal();
    },
  },
};
</script>

<style></style>
